import { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";

import ModalLance from "./ModalOrganizacoes/";

import {
    LoginOrganizacao,
    Login,
} from "../../../Interfaces/Login/LoginInterface";
import { Organizacao } from "../../../Interfaces/Login/OrganizacaoInterface";

import { replaceClass } from "../../../Tools/Classtools";

import {
    LoginOrganizacaoController,
    LoginUser,
} from "../../../Controllers/Login/LoginController";
import { useUserInfor } from "../../../Context/User";
import { GetOrganizacaoController } from "../../../Controllers/Organizacao/Organizacao";
import { GetUserInfor } from "../../../Controllers/Users/UsersController";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWindows } from "@fortawesome/free-brands-svg-icons";
import { useMsal } from "@azure/msal-react";
import {
    FazerLoginADController,
    FazerLoginOrganizacaoADController,
    LoginMSAL,
} from "../../../Controllers/Login/LoginAD/LoginADControllers";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import { Spinner } from "../../../Components/Loding/SpinnerPadrao";
import { useEffect } from "react";
import StorageManagerCapys from "../../../Tools/Storage";

interface ILogin extends LoginOrganizacao {
    token_msal: string;
}

export function LoginForm() {
    const { instance } = useMsal();

    const location = useLocation();
    const isSSOnlyPage = location.pathname.includes("/sso");

    const [StatusModal, setStatusModal] = useState(false);

    const { setUserInfor, setOrgInfor, updateConfig } = useUserInfor();

    const { register, handleSubmit, formState } = useForm();

    const [lstOrganizacoes, setLstOrganizacoes] =
        useState<Array<Organizacao>>();
    const [Usuario, setUsuario] = useState<LoginOrganizacao>();
    const [tokenMSAL, setTokenMSAL] = useState<string>();

    const history = useHistory();

    useEffect(() => {
        const storageManagerDefaultSSO = new StorageManagerCapys(
            "DEFAULT_LOGIN_ONLY_SSO"
        );
        if (isSSOnlyPage) storageManagerDefaultSSO.set(true);
        else storageManagerDefaultSSO.remove();
    }, [isSSOnlyPage]);

    const Login = async (data: ILogin) => {
        const LoginOrgPromise = data.token_msal
            ? FazerLoginOrganizacaoADController(data.token_msal)
            : LoginOrganizacaoController(data);
        await LoginOrgPromise.then(async (response) => {
            setLstOrganizacoes(response);
            setUsuario(data);
            if (response.length > 1) {
                setStatusModal(true);
            } else {
                const user: Login = {
                    Email: data.Email,
                    Password: data.Password,
                    IDOrganizacao: response[0].ID_ORGANIZACAO,
                };

                const LoginUserPromise = data.token_msal
                    ? FazerLoginADController(
                          data.token_msal,
                          user.IDOrganizacao
                      )
                    : LoginUser(user);
                await LoginUserPromise.then((token) => {
                    history.push("/Geral");
                    GetOrganizacaoController().then((res) => {
                        setOrgInfor(res);
                    });
                    GetUserInfor().then((response) => {
                        setUserInfor({ ...response, token });
                    });

                    updateConfig();
                }).catch((err) => {
                    console.log(err);
                });
            }
        }).catch((err) => {});
    };

    const { execute: LoginAD, loading: loadingAD } = useAsyncCallback(
        async () => {
            try {
                const msal_token = await LoginMSAL(instance);
                setTokenMSAL(msal_token);
                await Login({
                    Email: "",
                    Password: "",
                    token_msal: msal_token,
                });
            } catch (error) {
                console.log(
                    "Usuário não efetuou login microsoft - " +
                        (error as any)?.message
                );
            }
        }
    );

    const { execute: onSubmit, loading } = useAsyncCallback(Login);

    return (
        <div className="login-form login-signin">
            <div className="text-center mb-10 mb-lg-20">
                <h2 className="font-weight-bold">Login</h2>
                <p className="text-muted font-weight-bold">
                    {isSSOnlyPage
                        ? "Entre com sua conta Microsoft"
                        : "Entre com seu email e senha"}
                </p>
            </div>
            <form
                className="form"
                id="kt_login_signin_form"
                onSubmit={handleSubmit(onSubmit)}
            >
                {!isSSOnlyPage && (
                    <>
                        <div className="form-group py-3 m-0">
                            <input
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                    formState.errors.Email && "is-invalid"
                                }`}
                                type="Email"
                                placeholder="Email"
                                name="Email"
                                ref={register({
                                    required: "Insira o seu e-mail",
                                })}
                            />
                            <div className="invalid-feedback">
                                {formState.errors.Email
                                    ? formState.errors.Email.message
                                    : ""}
                            </div>
                        </div>
                        <div className="form-group py-3 border-top m-0">
                            <input
                                className={`form-control h-auto border-0 px-0 placeholder-dark-75 ${
                                    formState.errors.Password
                                        ? "is-invalid"
                                        : ""
                                } `}
                                id="loginFormPassword"
                                type="Password"
                                placeholder="Password"
                                ref={register({
                                    required: "Insira a sua senha",
                                })}
                                name="Password"
                            />
                            <div className="invalid-feedback">
                                {formState.errors.Password
                                    ? formState.errors.Password.message
                                    : ""}
                            </div>
                        </div>
                        <div className="d-flex flex-wrap g-5 justify-content-center alig-items-end">
                            <div className="form-group d-flex flex-wrap justify-content-between align-items-center">
                                <span
                                    aria-disabled={loading}
                                    id="kt_login_forgot"
                                    role={!loading ? "button" : undefined}
                                    onClick={() => {
                                        if (!loading)
                                            replaceClass(
                                                "kt_login",
                                                "login-signin-on",
                                                "login-forgot-on"
                                            );
                                    }}
                                    className="text-muted text-hover-primary"
                                >
                                    Esqueceu sua senha ?
                                </span>
                            </div>
                            <div className="form-group flex-grow-1 d-flex justify-content-end">
                                <button
                                    type="submit"
                                    id="kt_login_signin_submit"
                                    className="btn btn-capys font-weight-bold px-9 py-4 my-3 d-flex g-2 align-items-center"
                                    disabled={loading || loadingAD}
                                >
                                    Entrar
                                    {loading && (
                                        <Spinner color="light" size="sm" />
                                    )}
                                </button>
                            </div>
                        </div>
                    </>
                )}

                <div className="my-5">
                    <button
                        className="btn btn-outline-dark d-flex w-100 g-2 align-items-center justify-content-center"
                        onClick={LoginAD}
                        type="button"
                        disabled={loading || loadingAD}
                    >
                        {loadingAD ? (
                            <Spinner size="sm" />
                        ) : (
                            <FontAwesomeIcon icon={faWindows} />
                        )}
                        Login pela Azure
                    </button>
                </div>
            </form>
            <ModalLance
                key="Modal"
                show={StatusModal}
                StateModalShow={setStatusModal}
                lstOrganizacoes={lstOrganizacoes}
                usuario={Usuario}
                tokenMSAL={tokenMSAL}
            />
        </div>
    );
}
